import * as Joi from 'joi';
import { getEmailSchema } from '../../../utils/JoiUtils';

export const validatePasswordStrength = (value: string, helpers: any) => {
  let passwordStrength = 0;
  if (value.match(/[a-z]/)) {
    passwordStrength += 1;
  }
  if (value.match(/[A-Z]/)) {
    passwordStrength += 1;
  }
  if (value.match(/[0-9]/)) {
    passwordStrength += 1;
  }
  if (value.match(new RegExp('[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>/?\\s]'))) {
    passwordStrength += 1;
  }
  if (passwordStrength >= 2) {
    return value;
  }
  return helpers.error('string.pattern.name');
};

const jobStatusReportEmailSchema = Joi.object({
  password: Joi.string().required().min(6).max(12).custom(validatePasswordStrength, 'Validate password strength').messages({
    'string.empty': 'Password is not allowed to be empty.',
    'string.min': 'Please enter at least 6 characters for password',
    'string.max': 'Please enter at most 12 characters for password',
    'string.pattern.name': 'Password is too weak',
  }),
  emails: Joi.array()
    .required()
    .min(1)
    .items(getEmailSchema("Email")),
});

export default jobStatusReportEmailSchema;
